import { PricingCompanySizeE } from '@core/billing-types';

export const getPricingCompanySize = (
  selectedCompanySize: string | null | undefined,
): PricingCompanySizeE | null => {
  if (!selectedCompanySize) return null;
  if (Object.values(PricingCompanySizeE).includes(<PricingCompanySizeE>selectedCompanySize)) {
    return <PricingCompanySizeE>selectedCompanySize;
  }
  return PricingCompanySizeE['151+'];
};
